// Ring Size Info Toggle Script for Infinite Options
(function() {
  'use strict';

  // Get settings from theme settings
  const settings = window.ringSizeSettings || {
    enableInfoToggle: true,
    ringSizeInfoText: 'Please select your ring size. If you\'re unsure of your size, you can order a free ring sizer or measure at home.'
  };

  // Only initialize if the feature is enabled
  if (!settings.enableInfoToggle) {
    return;
  }

  // Helpers for slide toggle
  function slideDown(el) {
    el.style.removeProperty('display');
    let display = window.getComputedStyle(el).display;
    if (display === 'none') display = 'block';
    el.style.display = display;
    const height = el.scrollHeight;
    el.style.overflow = 'hidden';
    el.style.maxHeight = '0px';
    el.offsetHeight; // force reflow
    el.style.transition = 'max-height 250ms ease';
    el.style.maxHeight = height + 'px';
    window.setTimeout(() => {
      el.style.removeProperty('max-height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.classList.add('active');
    }, 260);
  }

  function slideUp(el) {
    el.style.overflow = 'hidden';
    el.style.transition = 'max-height 250ms ease';
    el.style.maxHeight = el.scrollHeight + 'px';
    el.offsetHeight; // force reflow
    el.style.maxHeight = '0px';
    window.setTimeout(() => {
      el.style.display = 'none';
      el.style.removeProperty('max-height');
      el.style.removeProperty('overflow');
      el.style.removeProperty('transition');
      el.classList.remove('active');
    }, 260);
  }

  function toggleInfo(el) {
    if (!el) return;
    const isHidden = window.getComputedStyle(el).display === 'none' || el.style.display === 'none' || !el.classList.contains('active');
    if (isHidden) slideDown(el); else slideUp(el);
  }

  function buildInfoContentHTML() {
    const infoText = settings.ringSizeInfoText || '';
    return `<p class="ring-size-intro">${infoText}</p>`;
  }

  function getOrCreateInfoPanel(referenceLabel) {
    let panel = document.getElementById('ring-size-info');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.id = 'ring-size-info';
    panel.className = 'ring-size-info-text';
    panel.style.display = 'none';
    panel.innerHTML = buildInfoContentHTML();

    // Find the select element or the parent container
    const selectElement = document.querySelector('#infiniteoptions-container select[name="properties[Ring Size]"]');
    const selectParent = selectElement ? selectElement.closest('.spb-select') : null;

    if (selectParent && selectParent.parentNode) {
      selectParent.parentNode.insertBefore(panel, selectParent.nextSibling);
    } else if (referenceLabel && referenceLabel.parentNode) {
      referenceLabel.parentNode.insertBefore(panel, referenceLabel.nextSibling);
    } else {
      document.body.appendChild(panel);
    }
    return panel;
  }

  // Use event delegation to handle clicks on the ring size info toggle
  document.addEventListener('click', function(e) {
    // Handle JavaScript-created icon
    if (e.target && (e.target.id === 'ring-size-info-toggle' || e.target.closest('#ring-size-info-toggle'))) {
      e.preventDefault();
      e.stopPropagation();

      // Find the label using multiple methods
      let ringSizeLabel = document.querySelector('#infiniteoptions-container label[id*="Ring Size"]');
      if (!ringSizeLabel) {
        const selectElement = document.querySelector('#infiniteoptions-container select[name="properties[Ring Size]"]');
        if (selectElement) {
          const parentDiv = selectElement.closest('div');
          if (parentDiv) {
            ringSizeLabel = parentDiv.querySelector('label');
          }
        }
      }

      const panel = getOrCreateInfoPanel(ringSizeLabel);
      toggleInfo(panel);
      return;
    }

    // Handle CSS pseudo-element icon (fallback) - check if click is on the icon area
    const container = document.getElementById('infiniteoptions-container');
    if (!container) return;

    // Try to find Ring Size label that was clicked
    let ringSizeLabel = e.target.closest('label[id*="Ring Size"]');
    if (!ringSizeLabel) {
      // Check if we clicked a label in a div that has Ring Size select
      const selectElement = container.querySelector('select[name="properties[Ring Size]"]');
      if (selectElement) {
        const parentDiv = selectElement.closest('div');
        if (parentDiv) {
          const label = parentDiv.querySelector('label');
          if (label && (e.target === label || label.contains(e.target))) {
            ringSizeLabel = label;
          }
        }
      }
    }

    if (ringSizeLabel && ringSizeLabel.closest('#infiniteoptions-container')) {
      // Check if click is in the icon area (right side of label)
      const rect = ringSizeLabel.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const labelWidth = rect.width;

      if (clickX > labelWidth - 30) { // Icon area
        e.preventDefault();
        e.stopPropagation();
        const panel = getOrCreateInfoPanel(ringSizeLabel);
        toggleInfo(panel);
      }
    }
  }, true); // Use capture phase

  // Function to set up the info icon and content
  function setupRingSizeInfoToggle(_retryCount = 0) {
    const MAX_RETRIES = 20;
    const RETRY_DELAY = 300;

    const container = document.getElementById('infiniteoptions-container');
    if (!container) {
      if (_retryCount < MAX_RETRIES) {
        setTimeout(() => setupRingSizeInfoToggle(_retryCount + 1), RETRY_DELAY);
      }
      return;
    }

    // Find the ring size label with multiple methods
    let ringSizeLabel = container.querySelector('label[for*="Ring Size"]');
    if (!ringSizeLabel) {
      ringSizeLabel = container.querySelector('label[id*="Ring Size"]');
    }
    if (!ringSizeLabel) {
      ringSizeLabel = container.querySelector('label.spb-productdescfont[id*="Ring Size"]');
    }
    if (!ringSizeLabel) {
      // Try to find the label in the parent div that contains the Ring Size select
      const selectElement = container.querySelector('select[name="properties[Ring Size]"]');
      if (selectElement) {
        const parentDiv = selectElement.closest('div');
        if (parentDiv) {
          ringSizeLabel = parentDiv.querySelector('label');
        }
      }
    }
    if (!ringSizeLabel) {
      // Try to find any label that mentions ring size
      const candidates = container.querySelectorAll('label, .spb-label-tooltip label, .spb-label-tooltip, .spb-productdescfont');
      for (let i = 0; i < candidates.length; i++) {
        const el = candidates[i];
        const text = (el.textContent || '').toLowerCase();
        if (text.includes('ring size') || text.includes('ring_size')) {
          ringSizeLabel = el.tagName.toLowerCase() === 'label' ? el : el.querySelector('label') || el;
          break;
        }
      }
    }

    if (!ringSizeLabel) {
      if (_retryCount < MAX_RETRIES) {
        setTimeout(() => setupRingSizeInfoToggle(_retryCount + 1), RETRY_DELAY);
      }
      return;
    }

    // Skip if already has info toggle
    if (ringSizeLabel.querySelector('#ring-size-info-toggle')) {
      return;
    }

    // Create the info toggle container
    const infoToggleContainer = document.createElement('span');
    infoToggleContainer.className = 'ring-size-info-container';
    infoToggleContainer.id = 'ring-size-info-toggle';
    infoToggleContainer.style.cssText = `
      margin-left: 8px;
      cursor: pointer;
      display: inline-flex;
      align-items: center;
    `;

    // Create the info icon: small circle with i, black border, white background
    const infoIcon = document.createElement('span');
    infoIcon.className = 'ring-size-info-icon';
    infoIcon.textContent = 'i';
    infoIcon.style.cssText = `
      display: inline-flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      line-height: 18px;
      font-size: 12px;
      font-weight: 600;
      color: #000;
      background: #fff;
      border: 1px solid #000;
      border-radius: 50%;
      text-transform: none;
      letter-spacing: 0;
    `;

    infoToggleContainer.appendChild(infoIcon);

    // Add the toggle to the label
    ringSizeLabel.appendChild(infoToggleContainer);

    // Create the info content div
    const infoContent = document.createElement('div');
    infoContent.id = 'ring-size-info';
    infoContent.className = 'ring-size-info-text';
    infoContent.style.cssText = `
      display: none;
      margin-top: 6px;
      padding: 0;
      background: transparent;
      border: 0;
      border-radius: 0;
      font-size: 13px;
      line-height: 1.5;
      color: inherit;
      overflow: hidden;
    `;

    // Set content from settings
    infoContent.innerHTML = buildInfoContentHTML();

    // Insert the info content after the label's parent
    const selectElement = container.querySelector('select[name="properties[Ring Size]"]');
    const selectParent = selectElement ? selectElement.closest('.spb-select') : null;

    if (selectParent && selectParent.parentNode) {
      selectParent.parentNode.insertBefore(infoContent, selectParent.nextSibling);
    } else {
      // Fallback: insert after label's parent
      ringSizeLabel.parentNode.insertBefore(infoContent, ringSizeLabel.nextSibling);
    }
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setupRingSizeInfoToggle());
  } else {
    setupRingSizeInfoToggle();
  }

  // Set up a mutation observer to handle dynamic content changes (like Infinite Options)
  const observer = new MutationObserver(function(mutations) {
    for (let mutation of mutations) {
      if (mutation.type === 'childList') {
        const hasInfiniteOptions = mutation.target.id === 'infiniteoptions-container' ||
                                  (mutation.target.querySelector && mutation.target.querySelector('#infiniteoptions-container'));

        if (hasInfiniteOptions) {
          setTimeout(setupRingSizeInfoToggle, 100);
          break;
        }
      }
    }
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: false
  });

  // Listen for variant change events
  document.addEventListener('variant:change', function() {
    setTimeout(setupRingSizeInfoToggle, 200);
  });

})();
